import React = require('react');
import l10n from '../../util/l10n';
import {BaseViewProps, ImageViewProps, ImageWithTextViewProps, ImageModuleData} from './interfaces';
import {setCurrentTab} from '../../module-action-bar/index';
import AppRegistry from '../../AppRegistry';

function getStore() {
    return AppRegistry.getStoreProvider().getStore();
}

// TODO this component need to be updated to be 100% compabile with the server rendering
// currently it is reduced to serve well for the editing use-case
export default class ImageWebView extends React.Component<BaseViewProps, {}> {
    private textElement: HTMLElement;

    componentDidMount() {
        const props = this.props as BaseViewProps;
        if (this.hasTextProps(props)) {
            props.module.initCKEditor(this.textElement);
        }
    }

    render() {
        const data = this.props.payload;
        const alignmentClass = this.getAlignmentClass();
        const props = this.props as BaseViewProps;
        const hasText = this.hasTextProps(props);

        let text: string;

        if (this.hasTextProps(props) && props.payload.moduleText) {
            text = props.payload.moduleText;
        } else if (this.hasTextProps(props)) {
            text = '<< ' + l10n("common.newImageWithText") + ' >>';
        }

        return (
        <div
            className={`
                clearover
                ${hasText ? "" : "imageSubtitle"}
                ${data.imageFit && !this.isFullWidth() && !this.hasVisualSize() ? "imageFitWidth" : ""}
            `}
            id={`
                ${hasText ? "textWithImage" : "imageSubtitle"}-${this.props.moduleId}
            `}
        >
            <div
                className={`align-container ${alignmentClass}`}
                style={this.getContentStyle()}
            >
                <a className="imagewrapper"
                    href="javascript:;"
                    title={data.caption}
                >
                    <img
                        id={`image_${data.imageId}`}
                        src={data.imageUrl}
                        alt={data.imageAlt}
                        style={hasText ? this.getTextImageStyle() : this.getImageStyle()}
                        onClick={data.imageAnimated ? this.switchToImageTab : null}
                    />
                </a>
                {
                    this.supportsCaption() && data.caption ?
                    <span className="caption">
                        {data.caption}
                    </span>
                    : null
                }
            </div>
            {
            this.hasTextProps(props) ?
            <div
                className="textwrapper"
                dangerouslySetInnerHTML={{__html: text}}
                ref={(ref) => this.textElement = ref}
            />
            : null
            }
        </div>
        );
    }

    private switchToImageTab = () => {
        // auto switch tabs if needed
        const store = getStore();
        store.dispatch(setCurrentTab({nextTab: 0, currentTabWhitelist: [3, 4]}));
    }

    // Attempt to animate.
    // TODO: Reconsider later with IIE.
    // private getAlignmentStyle() {
    //     const data = this.props.payload;
    //     const contentWidth = this.props.module.getContent().offsetWidth;
    //     const containerWidth = this.props.module.getContainer().offsetWidth;
    //     switch (data.imagePosition) {
    //         case 2: return {
    //             marginLeft: containerWidth - contentWidth
    //         };
    //         case 3: return {
    //             marginLeft: containerWidth / 2 - contentWidth / 2
    //         };
    //         default: return {
    //             marginLeft: 0
    //         };
    //     }
    // }

    private hasImageProps(props: BaseViewProps): props is ImageViewProps {
        return !props.module.hasText;
    }

    private hasTextProps(props: BaseViewProps): props is ImageWithTextViewProps {
        return props.module.hasText;
    }

    private isFullWidth() {
        const props = this.props as BaseViewProps;
        return this.hasImageProps(props) && props.payload.isFullwidth;
    }

    private getAlignmentClass() {
        const props = this.props as BaseViewProps;
        if (this.hasImageProps(props) && !props.payload.supports.imageAlign) {
            return '';
        }

        const hasText = this.hasTextProps(props);
        switch (this.props.payload.imagePosition) {
            case 2: return hasText ? "imgright" : "align-right";
            case 3: return hasText ? "" : "align-center";
            default: return hasText ? "imgleft" : "align-left";
        }
    }

    private getTextImageStyle() {
        const data = this.props.payload;
        const style = this.hasVisualSize() ? {
            width: this.getWidth(),
            height: this.getHeight(),
            visibility: data.imageAnimated ? 'visible' : 'hidden'
        } : {
            width: "100%",
            height: "auto"
        };
        return style;
    }

    private getImageStyle() {
        const data = this.props.payload;
        const props = this.props as BaseViewProps;
        const supportsResize = this.hasImageProps(props) && props.payload.supports.imageResize;
        let style: React.CSSProperties;

        if (this.hasVisualSize() && supportsResize) {
            style = {
                maxWidth: 'none',
                width: this.getWidth(),
                height: this.getHeight()
            };
        } else if (supportsResize) {
            let maxWidth: string;
            if (this.hasImageProps(props) && !props.payload.supports.imageFullWidth) {
                maxWidth = undefined;
            } else {
                maxWidth = this.isFullWidth() ? "none" : data.imageWidth + 'px';
            }
            style = {
                width: '100%',
                maxWidth,
                height: 'auto'
            };
        } else {
            style = {
                height: 'auto'
            };
        }
        return Object.assign(style, {
            //TODO: Change the visibility when the Webview is used for normal rendering without editing.
            visibility: this.props.payload.imageAnimated ? 'visible' : 'hidden'
        });
    }

    private getContentStyle() {
        const props = this.props as BaseViewProps;
        let style: React.CSSProperties;
        if (this.hasTextProps(props)) {
            style = {
                maxWidth: "100%",
                width: this.getWidth()
            };
        } else if (this.hasImageProps(props) && props.payload.supports.imageResize) {
            style = {
                maxWidth: this.isFullWidth() ? "none" : this.getWidth(),
                width: "100%"
            };
        } else {
            style = {};
        }
        return style;
    }

    private supportsCaption() {
        // Text with image unconditionally supports caption
        return this.props.module.hasText ||
            (this.props.payload as ImageModuleData).supports.imageCaption;
    }

    private getWidth() {
        const data = this.props.payload;
        return data.visualImageWidth || data.imageWidth;
    }

    private getHeight() {
        const data = this.props.payload;
        return data.visualImageHeight || data.imageHeight;
    }

    private hasVisualSize() {
        return this.props.payload.visualImageHeight && this.props.payload.visualImageWidth;
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/image/WebView.tsx
 **/